import {NgModule} from '@angular/core';

import {SharedModule} from '../shared/shared.module';
import {CarouselModule} from 'ngx-owl-carousel-o';
import {LazyLoadImageModule} from 'ng-lazyload-image';
import {StarsRoutingModule} from './stars-routing.module';
import {StarsSingleComponent} from './components/stars-single/stars-single.component';
import {StarsComponent} from './components/stars/stars.component';
import {AddAddonComponentModalComponent} from './components/add-addon/add-addon.component';

const MODULES = [SharedModule, StarsRoutingModule];

const COMPONENTS = [StarsComponent, StarsSingleComponent, AddAddonComponentModalComponent];

const SERVICES = [];

@NgModule({
    imports: [...MODULES, CarouselModule, LazyLoadImageModule],
    providers: [...SERVICES],
    declarations: [...COMPONENTS],
    entryComponents: [
        AddAddonComponentModalComponent
    ]
})
export class StarsModule {
}
